<template>
    <div>
        <b-row>
            <hr/>
        </b-row>
        <b-row align-v="center">
            <b-col cols="12" md="3">
                <b-button block @click="prev" v-if="prevExist">{{ prevTitle }}</b-button>
            </b-col>
            <b-col cols="12" md="6" class="text-center">
                <span>Шаг {{step_num}} : {{ stepItem.title }}</span>
                <small style="color: #999999"><br/>uuid: {{ requestUuid}}</small>
            </b-col>
            <b-col cols="12" md="3">
                <b-button block variant="success" @click="next" v-if="nextExist" :disabled="!allow_next">{{ nextTitle }}</b-button>
            </b-col>
        </b-row>
        <eco-basement />
    </div>
</template>

<script>
import steps from '../steps.js'

export default {
    props: {
        step_num : Number,
        allow_next: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {

        }
    },
    methods:{
        save() {
            this.$store.dispatch('REMEMBER_COMPANY')
        },
        next() { 
            this.save()
            this.$router.push(steps.get(this.step_num + 1).name) 
        },
        prev() { 
            this.save()
            let prevStep = this.step_num - 1
            if(prevStep === 0 || prevStep === steps.items.length - 2) {
                this.$router.push('/') 
            } else {
                this.$router.push(steps.get(prevStep).name) 
            }
        }
    },
    computed: {
        nextExist() { return this.step_num < steps.items.length - 1 },
        nextTitle() { 
            let nextStep = this.step_num + 1
            if(nextStep === steps.items.length - 1) return 'Отправить заявку!'
            return `Далее: шаг ${this.step_num + 1}`
        },

        prevExist() { return this.step_num > 0 },
        prevTitle() { 
            let prevStep = this.step_num - 1
            if(prevStep === 0 || prevStep === steps.items.length - 2) return 'На главную'
            return `Назад: шаг ${this.step_num - 1}`
        },

        stepItem() { return steps.get(this.step_num) },
        requestUuid() { return this.$store.getters.UUID ? this.$store.getters.UUID : 'n/a'}
    }
}
</script>